import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-question-consensus',
  templateUrl: './question-consensus.component.html',
  styleUrls: ['./question-consensus.component.scss'],
  standalone: false
})
export class QuestionConsensusComponent {
  @Input() question: any;
  @Input() editable: boolean = false;
  @Input() isResponse: boolean = false;

  constructor() {}

  get getCustoms() {
    return this.question.customs;
  }
}
